import { Block } from 'baseui/block';


import { IControlledHeatingOutletRelease } from './types'
import { LabelLarge } from 'baseui/typography';
import { VscPassFilled, VscCircleLarge } from 'react-icons/vsc';
import { FormattedMessage } from 'react-intl';
import { themedUseStyletron } from '../../../../theme/customTheme';
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper';

export function OverviewPanel(props: IControlledHeatingOutletRelease) {
    const [css, theme] = themedUseStyletron();
    return (
        <OverviewPanelWrapper {...props}>
            <Block display={'flex'} alignItems='center' flexDirection='row' gridGap={theme.sizing.scale400}>
                {props.release &&
                    <>
                        <VscPassFilled color={theme.appColors.aggregate.on} size={theme.sizing.scale800}></VscPassFilled>
                        <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>
                    </>
                }
                {!props.release &&
                    <>
                        <VscCircleLarge color={theme.appColors.aggregate.off}  size={theme.sizing.scale800}></VscCircleLarge>
                        <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>
                    </>
                }

            </Block>
        </OverviewPanelWrapper>
    );
}